// *** Services
import {
  SessionActions,
  PagoFAOActions,
  KiphuActions,
  SengridActions,
  IDVActions,
} from "services";

//**** REACT
import React, { useState, useContext, useLayoutEffect } from "react";
import { UsuarioContext } from "config/context/UsuarioProvider";
import { useHistory } from "react-router-dom";

import jwt from "jwt-decode";

//**** Material-UI
import { makeStyles } from "@material-ui/core/styles";

//**** Secciones
import SeleccionPeriodo from "./workflowCompra/SeleccionPeriodo/SeleccionPeriodo";
import ConfirmarCorreo from "./workflowCompra/ConfirmarCorreo/ConfirmarCorreo";
import ValidacionCI from "./workflowCompra/ValidacionCI/ValidacionCI";
import FacturacionPago from "./workflowCompra/FacturacionPago/FacturacionPago";
import ValidacionFinalDatos from "./workflowCompra/ValidacionFinalDatos/ValidacionFinalDatos";
import CargarPreguntas from "./workflowCompra/CargarPreguntas/CargarPreguntas";
import ContratoAdhesion from "./workflowCompra/contrato-de-adhesion/contrato";
/***evaluar si se utilizan */
import { ValidatorForm } from "react-material-ui-form-validator";
import Cabecera from "../CabeceraPie/Cabecera";
import PiePagina from "../CabeceraPie/PiePagina";
// *** core components
import Button from "components/CustomButtons/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
//**** Estilos
import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/latestOffersStyle";
const useStyles = makeStyles(styles);

const useStylesLoad = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function getWPUrl(path) {
  return path ? window.urlWP + path : window.urlWP;
}

export default function FlujoFES() {
  const history = useHistory();
  const classes = useStyles();
  const classesLoad = useStylesLoad();
  const [TestError, setTestError] = useState(
    "Existen campos obligatorio sin completar"
  );
  const [AlertisFormValid, setAlertisFormValid] = useState(true);
  const [CurrentUser, setCurrentUser] = useState(null);
  const [Progress, setProgress] = useState(true);
  const [btnDisable, setbtnDisable] = useState(false);
  const {
    usuario,
    setusuario,
    dataEmpresa,
    setdataEmpresa,
    question,
    setquestion,
    signupModalPin,
    setSignupModalPin,
    setplanUser,
    planUser,
  } = useContext(UsuarioContext);
  var formRef = React.createRef();

  useLayoutEffect(() => {
    setplanUser("CFES");
    const timer = setTimeout(() => {
      flujo();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  function flujo() {
    //const params = new URLSearchParams(window.location.search);
    //const token = params.get('token')
    //obtener jtw y deserealizar para obtener token
    //si no existe jwt entonces debo generar un token y una sesion
    //si existe token entonces hacer las validaciones que están a continuación
    if (localStorage.getItem("currentUser") === null) {
      localStorage.clear();
      //solicita token  y redireccionar esta misma url con token
      SessionActions.generarToken("CFES").then((responseToken) => {
        //hacer login
        SessionActions.login(responseToken.data).then((response) => {
          //buscar datos del usuario según token
          cargaInicial();
        });
      });
    } else {
      cargaInicial();
    }
  }
  async function sendContract() {
    const res = await SessionActions.postContract(usuario.token);
    if (!res) {
      setTestError("Ha ocurrido un error. Intente nuevamente o contáctenos.");
    } else {
      const DatosFacturacion = {};
      DatosFacturacion["id_datosFacturacion"] = dataEmpresa.id_datosFacturacion;
      DatosFacturacion["nombre"] = usuario.nombres;
      DatosFacturacion["actividadEconomica"] = usuario.selectedEnabledEmpresa
        ? dataEmpresa.actividadEconomica.actividadEconomica
        : "N/A";
      DatosFacturacion["codigo"] = dataEmpresa.actividadEconomica.codigo;
      DatosFacturacion["rut"] = dataEmpresa.rut;
      DatosFacturacion["razonSocial"] = usuario.selectedEnabledEmpresa
        ? dataEmpresa.razonSocial
        : "N/A";
      DatosFacturacion["email"] = usuario.selectedEnabledEmpresa
        ? dataEmpresa.email
        : usuario.email;
      DatosFacturacion["telefono"] = usuario.selectedEnabledEmpresa
        ? dataEmpresa.telefono
        : usuario.celular;
      DatosFacturacion["direccion"] = usuario.selectedEnabledEmpresa
        ? dataEmpresa.direccion
        : usuario.direccion;
      DatosFacturacion["token"] = usuario.token;
      PagoFAOActions.DatosFacturacion(DatosFacturacion).then(() => {
        KiphuActions.GeneraPago(usuario.token).then((responsePago) => {
          window.location.href = responsePago.data;
        });
      });
    }
  }
  function cargaInicial() {
    setCurrentUser(localStorage.getItem("currentUser").replace('"', ""));
    const userToken = jwt(localStorage.getItem("currentUser").replace('"', "")); // decode your token here
    //obtener token desde jwt
    setusuario({
      nombres: "",
      apellidos: "",
      rut: "",
      numserie: "",
      email: "",
      celular: "",
      direccion: "",
      paso: "SELEC_PLAN",
      token: userToken.nameid,
      selectedEnabledPlan: planByUrl(history.location.search),
      selectedEnabledEmpresa: false,
      pin: "",
      esNotario: false,
      codNotario: "",
      tieneToken: false,
    });
    //si el token tiene id_solicitud y no existe el usuario en el storage entonces redireccionar al /
    SessionActions.ValidaToken(userToken.nameid).then((responseToken) => {
      if (
        responseToken.data === true &&
        localStorage.getItem("currentUser") !== null
      ) {
        //preguntar al back en que etapa quedo y asignar a paso (si apreta f5)
        SessionActions.traerEtapa(userToken.nameid).then((response) => {
          const { payload, success } = response.data;

          if (!success) {
            localStorage.clear();
            SessionActions.logout();
            history.push("/");
          } else {
            if (payload.numero > 1) {
              SessionActions.TraerDatosUsuario(userToken.nameid).then(
                (responseDataUser) => {
                  setusuario({
                    ...usuario,
                    paso: payload.codigo,
                    nombres: responseDataUser.data.nombres,
                    apellidos: responseDataUser.data.apellidos,
                    email: responseDataUser.data.email,
                    rut: responseDataUser.data.run,
                    celular: responseDataUser.data.telefono,
                    direccion: responseDataUser.data.direccion,
                    numserie: responseDataUser.data.numSerie,
                    selectedEnabledEmpresa:
                      responseDataUser.data.contieneEmpresa,
                    selectedEnabledPlan: responseDataUser.data.codigoPlan,
                    codDescuento: responseDataUser.data.codDescuento,
                    token: userToken.nameid,
                  });
                  switch (payload.codigo) {
                    case "CHALLENGE":
                      IDVActions.preguntasCI(userToken.nameid).then(
                        (response) => {
                          setquestion(response.data);
                          setProgress(false);
                          if (
                            response.data.question === null &&
                            response.data.retNo != null
                          )
                            setTestError(response.data.returnMessage);
                        }
                      );
                      break;
                    case "VAL_CI":
                      const personaci = {};
                      personaci["numSerie"] = responseDataUser.data.numSerie;
                      personaci["token"] = userToken.nameid;
                      personaci["run"] = responseDataUser.data.run;
                      // personaci["b64"] = usuario.b64;
                      IDVActions.ValidarCI(personaci).then((response) => {
                        setProgress(false);
                        // if (!response.data && usuario.b64 !== "") {
                        //   setusuario({ ...usuario, cienviado: true });
                        // } else {
                        //   if (!response.data) {
                        //     //si es true debe recargar la pagina
                        //     window.location.reload();
                        //   }
                        // }
                        if (response.data) {
                          window.location.reload();
                        }
                      });
                      break;

                    default:
                      setProgress(false);
                      break;
                  }
                }
              );
            } else if (payload.codigo === "SELEC_PLAN") {
              setProgress(false);
            }
          }
        });
      } else if (responseToken.data === true) {
        SessionActions.traerEtapa(userToken.nameid).then((response) => {
          const { payload } = response.data;
          if (payload.numero !== 1) {
            localStorage.clear();
            SessionActions.logout();
            history.push("/");
          } else setProgress(false);
        });
      } else {
        localStorage.clear();
        SessionActions.logout();
        history.push("/");
      }
    });
  }
  function planByUrl(search) {
    if (search.includes("plan=1")) {
      return "1AFES";
    } else if (search.includes("plan=2")) {
      return "2AFES";
    } else if (search.includes("plan=3")) {
      return "3AFES";
    } else {
      return "1AFES";
    }
  }
  function validateForm(origen) {
    setbtnDisable(true);
    formRef.current.checkInput();
    for (let i = 0; i < formRef.current.childs.length; i++) {
      const element = formRef.current.childs[i];
      element.validate(element.props.value);
    }
    formRef.current.isFormValid().then((response) => {
      setAlertisFormValid(response);
      if (response) {
        switch (usuario.paso) {
          case "DAT_FAC":
            if (
              dataEmpresa.actividadEconomica === "" ||
              dataEmpresa.actividadEconomica === undefined ||
              dataEmpresa.actividadEconomica === null
            ) {
              setdataEmpresa({ ...dataEmpresa, actividadEconomicaError: true });
              //error
              setAlertisFormValid(false);
            } else {
              cambioPaso(origen);
            }
            break;

          default:
            cambioPaso(origen);
            break;
        }
      } else {
        setbtnDisable(false);
      }
    });
  }
  //implementar flujo dependiendo de los pasos, el backend me debe decir en que paso voy
  function cambioPaso(origen) {
    switch (usuario.paso) {
      case "SELEC_PLAN":
        //crear registro en tabla persona
        const personaPlan = {};
        personaPlan["numSerie"] = usuario.numserie;
        personaPlan["token"] = usuario.token;
        personaPlan["direccion"] = usuario.direccion;
        personaPlan["telefono"] = usuario.celular;
        personaPlan["selectedEnabledPlan"] = usuario.selectedEnabledPlan;
        personaPlan["nombres"] = usuario.nombres;
        personaPlan["apellidos"] = usuario.apellidos;
        personaPlan["run"] = usuario.rut;
        personaPlan["email"] = usuario.email;
        personaPlan["planUser"] = planUser;
        personaPlan["contieneEmpresa"] = usuario.selectedEnabledEmpresa;
        personaPlan["codNotario"] = "";
        personaPlan["codDescuento"] = usuario.descuentoAplicado
          ? usuario.codDescuento
          : "";
        //buscar datos del usuario según token
        //guardar data usuario en el localstorage
        localStorage.setItem("datatUser", JSON.stringify(usuario));
        PagoFAOActions.seleccionarPlan(personaPlan).then(() => {
          setusuario({ ...usuario, paso: "VAL_EMAIL" });
          setbtnDisable(false);
        });
        break;
      case "VAL_EMAIL":
        if (signupModalPin.open) {
          setSignupModalPin({
            open: true,
            mensaje: "Estamos validando el código ingresado...",
          });
          //validar pin y pasar a paso 4 si tiene chequeado si es empresa de lo contrario a pagar
          SengridActions.validarPin(usuario.token, usuario.pin).then(
            (response) => {
              if (response.data) {
                if (!usuario.selectedEnabledEmpresa) {
                  setusuario({ ...usuario, paso: "ACEPTAR_CONTRATO" });
                } else {
                  setSignupModalPin({ mensaje: "", open: false });
                  //buscar etapa del usuario
                  setusuario({ ...usuario, paso: "DAT_FAC" });
                  setbtnDisable(false);
                }
              } else {
                SengridActions.enviarPin(usuario.token, usuario.email).then(
                  () => {
                    setSignupModalPin({
                      ...signupModalPin,
                      mensaje:
                        "El código ingresado no es válido, pero no te preocupes, hemos enviado un nuevo código",
                      modificarData: false,
                    });
                    setbtnDisable(false);
                  }
                );
              }
            }
          );
        } else if (signupModalPin.modificarData) {
          //consumir back para actualizar datos y levantar el modal pin(envia pin automatico)
          const personaPlan = {};
          personaPlan["numSerie"] = usuario.numserie;
          personaPlan["token"] = usuario.token;
          personaPlan["direccion"] = usuario.direccion;
          personaPlan["telefono"] = usuario.celular;
          personaPlan["selectedEnabledPlan"] = usuario.selectedEnabledPlan;
          personaPlan["nombres"] = usuario.nombres;
          personaPlan["apellidos"] = usuario.apellidos;
          personaPlan["run"] = usuario.rut;
          personaPlan["email"] = usuario.email;
          personaPlan["planUser"] = planUser;
          personaPlan["contieneEmpresa"] = usuario.selectedEnabledEmpresa;
          personaPlan["codDescuento"] = usuario.descuentoAplicado
            ? usuario.codDescuento
            : "";
          localStorage.setItem("datatUser", JSON.stringify(usuario));
          PagoFAOActions.seleccionarPlanUpdate(personaPlan).then(() => {
            window.location.reload();
          });
        }
        break;
      case "DAT_FAC":
        //actualizar los datos del usuario
        setusuario({ ...usuario, paso: "ACEPTAR_CONTRATO" });
        break;
      case "CHALLENGE":
        if (question.question === null && question.retNo != null) {
          localStorage.clear();
          SessionActions.logout();
          history.push("/");
        } else {
          //actualizar los datos del usuario
          const Respuesta = {};
          Respuesta["Token"] = usuario.token;
          Respuesta["Question"] = question.question;
          IDVActions.respuestasCI(Respuesta).then((response) => {
            if (response.data) window.location.reload();
          });
        }

        break;
      case "VAL_CI":
        const personaci = {};
        personaci["numSerie"] = usuario.numserie;
        personaci["token"] = usuario.token;
        personaci["run"] = usuario.rut;
        // personaci["b64"] = usuario.b64;
        IDVActions.ValidarCI(personaci).then((response) => {
          // if (!response.data && usuario.b64 !== "") {
          //   setusuario({ ...usuario, cienviado: true });
          // } else {
            // if (!response.data) {
            if (response.data) {
              //si es true debe recargar la pagina
              window.location.reload();
            } else {
              // setAlertisFormValid(false);
              setTestError(
                "El número de serie ingresado no es válido, pero no te preocupes, valida que sea el correcto e ingresalo nuevamente"
              );
            }
          // }
        });
        break;
      case "ACEPTAR_CONTRATO": {
        sendContract();
        break;
      }

      case "FIN":
        //actualizar los datos del usuario
        SessionActions.finalizar(usuario.token).then((response) => {
          if (response.data) {
            if (
              usuario.selectedEnabledPlan === "1AFES" ||
              usuario.selectedEnabledPlan === "2AFES" ||
              usuario.selectedEnabledPlan === "3AFES"
            ) {
              localStorage.clear();
              SessionActions.logout();
              if (origen === "descargar") history.push("/descargar-simple");
              else window.open(getWPUrl("/gracias-por-tu-compra/"), "_self");
            } else {
              localStorage.clear();
              SessionActions.logout();
              history.push("/");
            }
          }
        });
        break;
      default:
        //console.log("CASE DEFAULT: ")
        break;
    }
  }
  function btn_salir() {
    localStorage.clear();
    SessionActions.logout();
    window.location.href = `${window.urlWP}`;
  }
  return (
    <div>
      <Cabecera color="gray" />
      <div className={classes.section}>
        <div className={classes.container}>
          <Snackbar
            open={AlertisFormValid ? false : true}
            onClose={(e) => setAlertisFormValid(true)}
            autoHideDuration={9000}
          >
            <Alert severity="error">
              <b>ERROR:</b> {TestError}
            </Alert>
          </Snackbar>
          {Progress ? (
            <Backdrop className={classesLoad.backdrop} open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            <ValidatorForm ref={formRef} instantValidate={true}>
              {usuario.paso === "SELEC_PLAN" || usuario.paso === "VAL_EMAIL" ? (
                <SeleccionPeriodo codigo={usuario.token} />
              ) : null}
              {usuario.paso === "VAL_EMAIL" && (
                <ConfirmarCorreo
                  validateForm={validateForm}
                  setbtnDisable={setbtnDisable}
                />
              )}
              {usuario.paso === "DAT_FAC" && <FacturacionPago />}
              {usuario.paso === "ACEPTAR_CONTRATO" && (
                <ContratoAdhesion setbtnDisable={setbtnDisable} />
              )}
              {/* se carga siempre y cuando el usuario sea empresa de lo contrario pasa a pago */}
              {/* 5 es pago no es una pantalla */}
              {usuario.paso === "CHALLENGE" && <CargarPreguntas />}
              {usuario.paso === "VAL_CI" && <ValidacionCI />}
              {usuario.paso === "FIN" && <ValidacionFinalDatos />}
              {usuario.paso === "FIN" || usuario.paso === "VAL_CI" ? null : (
                <div style={{ float: "right", paddingRight: 80 }}>
                  <Button
                    color="primary"
                    onClick={() => validateForm()}
                    disabled={btnDisable}
                  >
                    Siguiente
                  </Button>
                </div>
              )}
              {usuario.paso === "FIN" && (
                <div>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <div style={{ position: "relative" }}>
                        <div style={{ position: "absolute", bottom: "200px" }}>
                          <Button
                            color="primary"
                            onClick={() => validateForm("descargar")}
                            disabled={btnDisable}
                          >
                            Descargar Ahora
                          </Button>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            bottom: "200px",
                            right: "0",
                          }}
                        >
                          <Button
                            color="primary"
                            onClick={() => validateForm()}
                            disabled={btnDisable}
                          >
                            Finalizar
                          </Button>
                        </div>
                      </div>
                    </GridItem>
                  </GridContainer>
                </div>
              )}
              {usuario.paso === "VAL_CI" && (
                <div>
                  <div style={{ float: "left", paddingRight: 80 }}>
                    <Button color="success" onClick={() => btn_salir()}>
                      Salir
                    </Button>
                  </div>
                  <div style={{ float: "right", paddingRight: 80 }}>
                    <Button color="success" onClick={() => validateForm()}>
                      {usuario.b64 !== ""
                        ? "solicitar validación manual"
                        : "Intentar Nuevamente"}
                    </Button>
                  </div>
                </div>
              )}
            </ValidatorForm>
          )}
        </div>
      </div>
      <PiePagina />
    </div>
  );
}
